import { useBrandLoaderData } from "../rootLoader.ts";
import { Helmet } from "react-helmet-async";
import PageTitle from "../../home/common/page-title/PageTitle.tsx";

export default function AppHead() {
  const brand = useBrandLoaderData();

  return (
    <>
      <Helmet>
        <link rel="icon" href={brand.favicon} />
      </Helmet>
      <PageTitle noHeading />
    </>
  );
}
